import React, { useEffect } from "react";

import Chrome from "IndividualApplication/Chrome";
import { enterInformationURL } from "IndividualApplication/urls";
import { individualURLHelper, AnalyticsEvent } from "IndividualApplication/utils";
import { useHistory } from "react-router-dom";

import { useGetApplicationQuery, useGetOfferedVisionPlansQuery, useUpdateIndividualApplicationMutation } from "../api";
import { IndividualNavSection } from "../Components/IndividualNavSection";
import { IndividualVisionPlanCard } from "../Components/IndividualVisionPlanCard";
import { SubBody } from "Cobalt/BodyText";
import Button from "Cobalt/Button";
import { Surface, SurfaceHeader, SurfaceSection } from "Cobalt/Surface";
import { Div } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("SelectIndividualPlanPage");

export const SelectVisionPlanPage = () => {
  useEffect(() => {
    AnalyticsEvent("individual_vision_viewed");
  }, []);
  const history = useHistory();
  const { data: individualApplication, isLoading } = useGetApplicationQuery({});
  const { data: visionPlans = [] } = useGetOfferedVisionPlansQuery({
    skip: isLoading || !individualApplication,
  });
  const [updateIndividualApplication] = useUpdateIndividualApplicationMutation();

  const resetIndividualVisionCart = async () => {
    await updateIndividualApplication({
      individualVisionPlanID: "",
      dependentEnrollmentVision: "",
    });

    history.push(individualURLHelper(enterInformationURL));
  };

  return (
    <Chrome title="Vision Plans">
      <Surface mt={5}>
        <SurfaceHeader>Add Individual Vision Plan</SurfaceHeader>
        <SurfaceSection>
          <Div className={bem("messageHeader")} mb={3}>
            <SubBody className={bem("messageHeader", "header")}>
              Since your employer does not offer vision insurance, you can enroll in an individual vision plan for yourself and your family.
            </SubBody>
            <Div className={bem("messageHeader", "linkButton")}>
              <Button onClick={resetIndividualVisionCart} color="tertiary">
                Continue Without Vision
              </Button>
            </Div>
          </Div>
        </SurfaceSection>
        <SurfaceSection>
          {!isLoading &&
            individualApplication &&
            visionPlans.map((plan, i) => (
              <Div key={plan.id} mt={i == 0 ? 0 : 4}>
                <IndividualVisionPlanCard mt={i == 0 ? 0 : 4} plan={plan} individualApplication={individualApplication} />
              </Div>
            ))}
        </SurfaceSection>
        <SurfaceSection>
          <IndividualNavSection page="vision" />
        </SurfaceSection>
      </Surface>
    </Chrome>
  );
};
